import { style, transition, trigger } from '@angular/animations';

export const slideAnimation = [
  trigger('slideInOut', [
    transition(':enter', [style({height: 0})]),
    transition(':leave', [style({height: 0})]),
  ])
];
